const bandRoleOption = ({band_name, band_role, kid_name, ordering, instrument}) => {

  if (!band_role || !kid_name || !instrument) return null;

  const band_role_data = {
    "order": ordering.band_role,
    "name": "band_role",
    "tracking": band_name ? "band_role" : "band_role_fallback",
    "colorOption": 1,
    "dataPoints": {
      kid_name,
      instrument,
      band_role,
      band_name
    }
  };
  return band_role_data;
}

export default bandRoleOption;

